import PropTypes from "prop-types";
import { useDictionary } from "../../../../../../../../utilities/hooks/UseDictionary";
import ProfileImage from "../../../../../../common/ProfileImage";

const PoiProviderItem = ({provider, onItemCLicked}) => {
    const dictionary = useDictionary();

    return (
        <tr
			className="slot-booking-container"
			key={provider.id}
			onClick={() => onItemCLicked(provider)}
		>
            <td>
                <div className="d-flex-center custom-experience-container">
                    <ProfileImage name={provider.brand_name} photo={provider.logo_url} size={{ width: 32, height: 32,fontSize: 14, lineHeight: 16 }}/>
                    <div className='custom-experience-title truncate' style={{marginLeft:8}} title={provider.brand_name}>{provider.brand_name}</div>
                </div>
            </td>
            <td>
                <div className="customer-details-field">
                    {(provider.feed_id) ? provider.feed_id : '-'}
                </div>
            </td>
        </tr>
    )
            
}

PoiProviderItem.propTypes = {
  provider: PropTypes.object,
  onItemCLicked: PropTypes.func
};

export default PoiProviderItem;